import type { SvgIconTypeMap } from '@mui/material';
import type { OverridableComponent } from '@mui/material/OverridableComponent';
import { SHORTLIST_LINE_ITEM_FACET_IDS } from './constants';
import { LineItemExtended } from './ShortlistLineItems';

export type ShortlistLineItemFacetId = (typeof SHORTLIST_LINE_ITEM_FACET_IDS)[keyof typeof SHORTLIST_LINE_ITEM_FACET_IDS];

export type ShortlistLineItemFacetLabels = Record<ShortlistLineItemFacetId, string>;


export enum InquiryStatusEnum {
    default = 'default',
    empty = '-',
    available = 'Available',
    notAvailable = 'Not Available',
    requestSent = 'Request Sent',
    alternateProposed = 'Alternate Proposed',
    informationRequested = 'Information Requested'
}

export type InquiryStatus = (typeof InquiryStatusEnum)[keyof typeof InquiryStatusEnum];

export type Type = {
    icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
        muiName: string;
    };
    disabled: boolean;
};

export type InquiryStatusType = {
    [key in InquiryStatus]: Type;
};

export type NotesIconClickHandler = (row: LineItemExtended) => void;
export type AttachmentsIconClickHandler = (row: LineItemExtended) => void;
export type InvitePersonHandler = (row: LineItemExtended) => void;
export type SummarizeIconClickHandler = (row: LineItemExtended) => void;
export type RepresentativeClickHandler = (personId: string) => void;